import http from './../http.interceptor.js';

export function baseConfig(params) {
	let pixelClick = {};
  pixelClick.oks = window.localStorage.getItem('pixel_oks') || window.document.documentElement.getAttribute('data-pixel_oks');
  pixelClick.bigo = window.localStorage.getItem('pixel_bigo') || window.document.documentElement.getAttribute('data-pixel_bigo');
	pixelClick.kwai = window.localStorage.getItem('pixel_kwai') || window.document.documentElement.getAttribute('data-pixel_kwai');
	pixelClick.fb = window.localStorage.getItem('pixel_fb') || window.document.documentElement.getAttribute('data-pixel_fb');
	return http.post('/v3.home/baseConfig', {
		isLOgin: true,
		pixel_click: pixelClick,
		...params
	});
}

export function homeBonus(params) {
  return http.post('/v3.share/homeBonus', {
    isLOgin: true,
    ...params
  });
}

export function songSheet(params) {
  //
  return http.get('/v3.home/songSheet', {
    isLOgin: true,
    ...params
  });
}
//game
export function favoriteGame(params) {
  //
  return http.post('/v3.game/favoriteGame', params);
}

export function popAndBanner(params) {
  //
  return http.get('/v3.home/popAndBanner', {
    isLOgin: true,
    ...params
  });
}

export function notification(params) {
  //
  return http.get('/v3.home/bulletins', {
    isLOgin: true,
    ...params
  });
}

export function jackpot(params) {
  //
  return http.get('/v3.home/jackpot', {
    isLOgin: true,
    ...params
  });
}

export function getGameList(params) {
  //
  return http.post('/v3.home/getGameList', {
    isLOgin: true,
    ...params
  });
}

export function getAllGameCategory(params) {
  //
  return http.post('/v3.home/getAllGameCategory', {
    isLOgin: true,
    ...params
  });
}

export function getDataByGameCategory(params) {
  //
  return http.post('/v3.home/getDataByGameCategory', {
    isLOgin: true,
    ...params
  });
}

export function userInfo(params) {
  //
  return http.post('/v3.user/userInfo', {
    isLOgin: true,
    ...params
  });
}

export function updatePersonalData(params) {
  //
  return http.post('/v3.user/updatePersonalData', params);
}

export function getBalance(params) {
  return http.post('/v3.user/getBalance', {
    isLOgin: true,
    ...params
  });
}

export function userMessage(params) {
  return http.post('/v3.user/userMessage', {
    isLOgin: true,
    ...params
  });
}

export function getAllGameList(params) {
  return http.post('/v3.home/getAllGameList', {
    isLOgin: true,
    ...params
  });
}

export function turntablePDD(params) {
  return http.post('/v3.activity/turntablePDD', {
    isLOgin: true,
    ...params
  });
}

export function signInPDD(params) {
  return http.post('/v3.activity/signInPDD', {
    isLOgin: true,
    ...params
  });
}

export function startPDDTurntable(params) {
  return http.post('/v3.activity/startPDDTurntable', {
    isLOgin: true,
    ...params
  });
}

export function signatureInit(params) {
  return http.post('/v3.other/contract', {
    isLOgin: true,
    ...params
  });
}
export function doSignature(params) {
  return http.post('/v3.other/doContract', {
    isLOgin: true,
    ...params
  });
}
